import React from 'react';
import { Separator, SeparatorProps } from 'react-aria-components';

import styles from './Menu.module.scss';

export const MenuSeparator = (props: SeparatorProps) => {
  return <Separator className={styles.MenuSeparator} {...props} />;
};
